import React, { ReactElement } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import classnames from 'classnames';
import configDefaults from './CKEditor.config';
import './rich-text-editor.scss';
import './ckeditor.min.css';

export interface IProps {
    id?: string;
    className?: string;
    label?: string | ReactElement;
    disabled?: boolean;
    value: string;
    validationError?: string | JSX.Element;
    config?: object;
    onChange(e, editor): void;
    onBlur?(e, editor): void;
    readonly?: boolean;
    dataTestId?: string;
    resizable?: boolean;
}

export const RichTextEditor = (props: IProps) => {
    const {
        className,
        label,
        value,
        validationError,
        onChange,
        config = configDefaults,
        onBlur,
        readonly,
        disabled = false,
        dataTestId,
        resizable = false,
    } = props;

    const { ClassicEditor } = window.ClassicEditor;

    return (
        <div className={classnames('rich-text-editor', { 'rich-text-editor--resizable': resizable }, className)} data-test-id={dataTestId}>
            <label className='oe-form-field__title'>{label}</label>
            <CKEditor
                config={config}
                editor={ClassicEditor}
                data={value}
                disabled={disabled || readonly}
                onBlur={onBlur}
                onChange={onChange}
            />
            {validationError && <span className='oe-form-field__error'>{validationError}</span>}
        </div>
    );
};

RichTextEditor.defaultProps = {
  className: 'oe-form-field__control',
  value: ''
};
